module.exports = __webpack_public_path__ + "img/fire-safety-life.da7a343b.svg";